import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../../utils';
import { withTheme } from 'styled-components';
import { styled } from '../../utils/styled';
import { propStyles } from '../../utils/propStyles';
import Icon from '../Icon';
import Badge from '../Badge';
import { camelCase } from 'change-case';
import { AccessibilityStore, EntityStore } from '../../stores';

const DocumentTitle = styled<any, any>(
    'button',
    'documentTitle',
    'documentMenuTitleControls'
)`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

DocumentTitle.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: '1 0 auto',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    textAlign: 'right',
    bgColor: 'transparent',
    borderStyle: 'none',
};

// Mobile Styles
const DocumentTitleControls = styled<any, any>(
    'div',
    'documentTitleControls',
    'documentMenuTitleControls'
)`
    ${propStyles};
`;

DocumentTitleControls.defaultProps = {
    display: 'flex',
    alignItems: 'center',
};

interface DocumentMenuTitleControlsTheme {
    DocumentTitle?: any;
    Icon?: any;
}

interface DocumentMenuTitleProps {
    theme: any;
    documents?: Array<any>;
    open?: boolean;
    showCount?: boolean;
    refTarget: any;
    accessibilityStore?: AccessibilityStore;
    entityStore?: EntityStore;
    columnId?: string;
    onClick(): void;
}

@inject('accessibilityStore', 'entityStore')
@observer
class DocumentMenuTitleControls extends Component<DocumentMenuTitleProps> {
    @computed
    get theme() {
        const { theme } = this.props;
        const componentTheme: DocumentMenuTitleControlsTheme = {};
        return { ...theme, ...componentTheme };
    }

    @computed
    get documentWithTitle() {
        const { documents } = this.props;
        return documents && documents.find(doc => doc && doc.title);
    }

    @computed
    get accessibilityContextForIcon(): string | undefined {
        let docTitle;
        const document = this.documentWithTitle;
        if (document) {
            docTitle = `for ${document.title}`;
        }
        return docTitle;
    }

    @computed
    get dataMetricsContext(): string {
        const document = this.documentWithTitle;
        if (document) {
            return `documentMenuTitle-${camelCase(document.title)}`;
        }
        return '';
    }

    @computed
    get documentsCount(): number {
        const { documents, entityStore, columnId } = this.props;
        if (documents && documents.length > 0) {
            return documents.length;
        }
        const entityKey = entityStore?.value?.clientCode;
        if (entityKey && columnId) {
            const selectedDocuments = entityStore?.entityGroupStore?.selectedGridDocuments.get(
                entityKey
            );
            if (selectedDocuments) {
                const columnDocuments = selectedDocuments.get(columnId);
                if (columnDocuments) {
                    return columnDocuments.size;
                }
            }
        }
        return 0;
    }

    render() {
        const {
            theme,
            onClick,
            open = false,
            children,
            showCount = false,
            refTarget,
            accessibilityStore,
        } = this.props;

        return (
            <DocumentTitle
                aria-label={accessibilityStore.buttonAccessibilityValue(
                    'DocumentTitleButton',
                    'Document Menu'
                )}
                ref={refTarget}
                onClick={e => {
                    e.stopPropagation();
                    onClick();
                }}
                data-metric-id={this.dataMetricsContext}
                {...theme.DocumentDropdownButton}
            >
                {children}
                <DocumentTitleControls>
                    {showCount && (
                        <Badge bgColor="primary">{this.documentsCount}</Badge>
                    )}
                    <Icon
                        fileName={
                            open
                                ? 'DocumentDropdownIconExpanded'
                                : 'DocumentDropdownIcon'
                        }
                        height="1.4em"
                        width="1.4em"
                        aria-hidden="true"
                        {...theme.DocumentDropdownIcon}
                        accessibilityContext={this.accessibilityContextForIcon}
                    />
                </DocumentTitleControls>
            </DocumentTitle>
        );
    }
}

export default withTheme(DocumentMenuTitleControls) as any;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentMenuTitleControls.tsx